<template>
<div>
    <b-button-group size="sm">
        <b-button :disabled="!rowData.presence==1" class="btn btn-primary btn-sm float-right" variant="primary" v-if="this.timer===true" @click="sendCmd(rowData.id, 'refresh',1000)" title='Refresh'>
            <i class="fa fa-refresh"></i>
        </b-button>
        &nbsp;&nbsp;&nbsp;
        <router-link :to="{name: 'Edit Device', params: { id: rowData.id }}" class="btn btn-primary"><i class="fa fa-cogs" title='Manage'></i></router-link>

    </b-button-group>
</div>
</template>

<script>
import Vue from 'vue'
import VueSweetalert2 from 'vue-sweetalert2'
Vue.use(VueSweetalert2)
export default {
    name: 'devices-actions',
    props: {
        rowData: {
            type: Object,
            required: true
        },
        rowIndex: {
            type: Number
        }
    },
    data() {
        return {
            isActive: true,
            timer: false,
        }
    },
    created() {
        this.timer = setInterval(this.enableTimer, 1000);
    },
    methods: {
        edit(id) {
            this.$swal('Edit', 'Edit Device ' + id, 'success')
        },
        enableTimer() {
            this.timer = true;
        },
        makeToast(variant = null, message = null) {
            this.$bvToast.toast(message, {
                // title: `Config Updated ${variant || 'default'}`,
                title: `Notification:`,
                variant: variant,
                toaster: 'b-toaster-top-center',
                solid: true
            });
        },
        sendCmd(id, op, wait) {
            this.isActive = false;
            let uri = `/api/devices/${this.rowData.id}/op?op=${op}`;
            axios.get(uri).then((response) => {

                if (response.data.success === true) {
                    const sec = wait > 1000 ?
                        ' seconds' :
                        ' second';
                    let msg = 'Request sent.' + ' Wait ' + wait / 1000 + sec;

                    this.makeToast('info', msg);
                    setTimeout(() => {
                        this.$parent.reload(); // current page=1
                        // this.$parent.refresh(); // current page does not change
                        this.isActive = true;
                    }, wait);
                } else {
                    this.makeToast('danger', 'Unable to update device.');
                }
            });
        },
    },
    beforeDestroy() {
        clearInterval(this.timer)
    },
}
</script>
